// extracted by mini-css-extract-plugin
export default {"root":"RecoverPassword__root--HTRPB4","center":"RecoverPassword__center--7zDpKw"};